/** Dominio puro de la cartera de cheques (Fase C) — sin supabase, testeable. */

export type CheckStatus =
  | 'in_portfolio'
  | 'deposited'
  | 'endorsed'
  | 'rejected'
  | 'returned_to_client'
  | 'voided';

export type CheckSourceType = 'customer_payment' | 'sale_payment';

export type CheckRow = {
  id: string;
  number: string;
  bank: string | null;
  drawer: string | null;
  issueDate: string | null;
  dueDate: string | null;
  amount: number;
  status: CheckStatus;
  sourceType: CheckSourceType;
  sourceId: string;
  customerId: string | null;
  branchId: string | null;
  expenseSettlementId: string | null;
  rejectionReason: string | null;
  createdAt: string;
  depositedAt: string | null;
  endorsedAt: string | null;
  rejectedAt: string | null;
  returnedAt: string | null;
  voidedAt: string | null;
};

export type CheckCommandOperation =
  | 'deposit'
  | 'endorse'
  | 'reject'
  | 'return_to_client'
  | 'back_to_portfolio';

/** Mensajes de error del RPC → copy accionable (error-mapping-observability). */
export function mapCheckCommandError(raw: string): string {
  if (raw.includes('check_not_found')) return 'No encontré el cheque. Recargá la cartera.';
  if (raw.includes('check_invalid_state')) return 'El cheque ya cambió de estado. Recargá la cartera.';
  if (raw.includes('check_endorse_payload_invalid')) return 'Falta elegir el gasto a pagar.';
  if (raw.includes('expense_not_found')) return 'No encontré el gasto elegido.';
  if (raw.includes('expense_not_active')) return 'Ese gasto ya está anulado o pagado.';
  if (raw.includes('permission') || raw.includes('forbidden')) {
    return 'No tenés permiso para esta operación. Pedilo al dueño.';
  }
  if (raw.includes('capability')) return 'La cartera de cheques no está habilitada.';
  if (raw.includes('operationId_required')) return 'Error interno: falta operationId.';
  return `No pude completar la operación: ${raw}`;
}

export const CHECK_STATUS_LABELS: Record<CheckStatus, string> = {
  in_portfolio: 'En cartera',
  deposited: 'Depositado',
  endorsed: 'Endosado',
  rejected: 'Rechazado',
  returned_to_client: 'Devuelto',
  voided: 'Anulado',
};

export const CHECK_HISTORY_STATUSES: CheckStatus[] = [
  'deposited',
  'endorsed',
  'rejected',
  'returned_to_client',
  'voided',
];

export type CheckDueBadge = 'due_today' | 'due_soon' | 'overdue' | 'no_date';

export function checkDueBadge(dueDate: string | null, todayIso: string): CheckDueBadge {
  if (!dueDate) return 'no_date';
  if (dueDate < todayIso) return 'overdue';
  if (dueDate === todayIso) return 'due_today';
  return 'due_soon';
}

export function checkDueBadgeLabel(badge: CheckDueBadge, dueDate: string | null, todayIso: string): string {
  switch (badge) {
    case 'overdue':
      return 'Vencido';
    case 'due_today':
      return 'Vence hoy';
    case 'due_soon': {
      const days = Math.round(
        (new Date(`${dueDate}T12:00:00`).getTime() - new Date(`${todayIso}T12:00:00`).getTime()) /
          86400000,
      );
      return days <= 1 ? 'Vence mañana' : `Vence en ${days} días`;
    }
    default:
      return 'Sin vencimiento';
  }
}
